import React from 'react';
import PropTypes from 'prop-types';
import './index.css';
import { useTranslation } from 'react-i18next';

const RestaurantStats = ({ landingPageData }) => {
    const { t } = useTranslation();

    // Default stats if landing page data isn't available
    const defaultStats = [
        { title: 'Orders Per Week', value: '500+' },
        { title: 'Customer Satisfaction', value: '98%' },
        { title: 'Delivery Time', value: '30 min' },
        { title: 'Years of Experience', value: '8+' }
    ];

    // Use stats from landing page if available, otherwise use defaults
    const stats = landingPageData?.landingPage?.stats?.length > 0
        ? landingPageData.landingPage.stats
        : defaultStats;

    // Skip stats that are used elsewhere (like ratings for the Reviews component)
    const filteredStats = stats.filter(stat =>
        !stat.title.toLowerCase().includes('rating') &&
        !stat.title.toLowerCase().includes('star') &&
        !stat.title.toLowerCase().includes('review')
    );

    // If no stats remain after filtering, don't render the component
    if (filteredStats.length === 0) {
        return null;
    }

    return (
        <div className="stats-container">
            <h2 className="stats-title">{t('landing.stats.title', 'Restaurant Stats')}</h2>
            <div className="stats-grid">
                {filteredStats.map((stat, index) => (
                    <div key={index} className="stat-card">
                        <h3 className="stat-value">{stat.value}</h3>
                        <p className="stat-title">{stat.title}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

RestaurantStats.propTypes = {
    landingPageData: PropTypes.object
};

export default RestaurantStats;